<template>
  <div :class="['modal', status]" :id="status">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 rounded-0 p-1">
        <div class="p-2 pt-2 pr-3 pb-3 pl-3 text-start" role="alert">
          <div class="modal-header border-0 d-flex align-items-start p-1">
            <h3 class="text-start"><strong>{{ title }}</strong>
            </h3>
            <button type="button" class="btn-close btn-close-modal " data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <p class="mt-2">
            {{ message }}
          </p>
        </div>
      </div>
    </div>
</div>

</template>
<script>
export default {
  name: "ModalAlertDefault",
  props: {
    message: String,
    title: String,
    status: String
    }
};

</script>
<style scoped>




.modal-content {
  width: 80vw;
  max-width: 600px;
  max-height: 80vh;
}

@media screen and (max-width: 720px) {
  .modal-content {
    height: auto !important; 
    width: 90vw;
    padding: 1rem; 
  }
}
</style>